export default "__VITE_ASSET__DBaGgdtG__"